import { render, staticRenderFns } from "./StudentsQuery.vue?vue&type=template&id=6e309f56&lang=pug"
import script from "./StudentsQuery.vue?vue&type=script&lang=js"
export * from "./StudentsQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports